module.exports = __webpack_public_path__ + "img/cmg-rotate-phone-to-portrait.33814b47.png";